import { useCallback } from 'react'
import { MdClose } from 'react-icons/md'
import { ButtonBack, ModalEmptyContainer, ModalEmptyDiv, ModalEmptyWrapper } from './style'
import ImgMark from '../../assets/logos/MarkLogo.svg'
import ImgNotes from '../../assets/logos/NotesLogo.svg'

interface IProps {
  typeModal: 'marks' | 'notes'
  close(): void
}

const ModalEmpty = ({ close, typeModal }: IProps) => {
  const handleCloseModal = (e) => {
    if (e.target.id === 'modalEmpyt') closeModal()
  }

  const closeModal = useCallback(() => {
    close()
  }, [close])

  return (
    <ModalEmptyWrapper id="modalEmpyt" onClick={handleCloseModal}>
      <ModalEmptyDiv>
        <button className="btnClose" id="fechar" onClick={closeModal}>
          <MdClose id="close" size={20} />
        </button>
        <ModalEmptyContainer>
          <h1>
            Você não possui {typeModal === 'marks' ? 'marcações' : 'anotações'} neste capítulo
          </h1>
          <p>
            Para criar uma {typeModal === 'marks' ? 'marcação' : 'anotação'}, selecione o texto e
            clique em "{typeModal === 'marks' ? 'Marcar' : 'Anotar'}"
          </p>
          <div className="ContainerImg">
            <img
              width="100%"
              height="100%"
              src={typeModal === 'marks' ? ImgMark : ImgNotes}
              alt="imgModal"
            />
          </div>

          <ButtonBack>
            <button type="submit" className="back-btn" id="modalEmpyt">
              Voltar
            </button>
          </ButtonBack>
        </ModalEmptyContainer>
      </ModalEmptyDiv>
    </ModalEmptyWrapper>
  )
}

export default ModalEmpty
